import React from 'react';
import './index.css';
import TextToSpeech from './txtTospeech.js';

export default function Projects() {
  return (
    <div className="sectionComponent">
      <h1 className="projh1">PROJECTS</h1>
      <TextToSpeech
        inputText={
          'Projects. Nasa data exploration project, Built a web application with a backend server that allows users to view data on exoplanets. Evite Java Clone, Coded a scalable Evite client that allows users to log in, create accounts or continue as guests, host, view, cancel or RSVP to parties/events. Towers of Hanoi, Used C++ to write a program that solves the towers of Hanoi in the most efficient way possible. ChromaCorrect,Google Chrome Extension for making websites more visually accessible to people with colorblindness. '
        }
      ></TextToSpeech>
      <dl>
        <dt>NASA Data Exploration Project</dt>
        <dd>Built a web application with a backend server that allows users to view data on exoplanets. </dd>
        <dt>Java Evite Clone</dt>
        <dd>Coded a scalable Evite client that allows users to log in, create accounts or continue as guests, host, view, cancel or RSVP to parties/events. </dd>
        <dt>Towers of Hanoi</dt>
        <dd>Used C++ to write a program that solves the towers of Hanoi in the most efficient way possible. </dd>
        <dt>ChromaCorrect</dt>
        <dd>Google Chrome Extension for making websites more visually accessible to people with colorblindness.</dd>
      </dl>
    </div>
  );
}
